import { render, staticRenderFns } from "./TabbarMain.vue?vue&type=template&id=21dc0a3a&scoped=true"
import script from "./TabbarMain.vue?vue&type=script&lang=js"
export * from "./TabbarMain.vue?vue&type=script&lang=js"
import style0 from "./TabbarMain.vue?vue&type=style&index=0&id=21dc0a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc0a3a",
  null
  
)

export default component.exports